module.exports = function(app) {

    require('./spending/receiptRequired')(app);
    require('./spending/claimsMatchingConfirm')(app);
    require('./spending/costSavingTools')(app);
    //new spending side bar menu additions
    require('./spending/debitCard')(app);
    require('./spending/manageSpendingAccount')(app);
    require('./spending/receipts')(app);
    require('./spending/clientListSelection')(app);
    require('./spending/groupSelection')(app);
    require('./spending/spendingClaims')(app);
    require('./spending/transactionHistory')(app);
    require('./spending/newClaims')(app);
    require('./spending/newReceipt')(app);
    require('./spending/spendingSummary')(app);
    require('./spending/spendingAccountSettings')(app);
    require('./spending/transactionHistory')(app);
    require('./spending/spendingForms')(app);


    app.service("spendingResourceServices", ["$q", "services", "sessionData", "$cookies", function($q, services, session, $cookies){

        var _accountInfoPromises = function(accountList){
            var promisesArray = [];
            var clientNumber = $cookies.get("mbrClientNumber");
            if(accountList){
                for(var y in accountList) {
                    var accountSummaryData = accountList[y];
                    var detailDeferred = services.dpsext.spendingAccountInfo().fetch(session.memberInfo,clientNumber,accountSummaryData.accountType);
                    promisesArray.push(detailDeferred);
                }
                return promisesArray;
            } else {
                return [];
            }
        };

        this.getSpendingAccounts = function(memberInfo, clientNumber){
            var memberInfo = memberInfo || session.memberInfo;
            var clientNumber = clientNumber || $cookies.get("mbrClientNumber");

            var hasDebitCard = false;
            var actionItems = null;
            var defaultSpendingObject = {
                accountFlag : {},
                accountList : [],
                hasDebitCard : false
            };

            if (!(memberInfo && clientNumber)) {
                var defer = $q.defer();
                defer.resolve(defaultSpendingObject);
                return defer.promise;
            }

            if (session.benefits && !session.benefits.spending) {
                var defer = $q.defer();
                defer.resolve(defaultSpendingObject);
                return defer.promise;
            }

            return services.dpsext.spendingAccountGlance().fetch(memberInfo, clientNumber).then(function(response){
                    var accountDataArray = response
                        && response.data
                        && response.data.repGetAccountsAtAGlanceReply
                        && response.data.repGetAccountsAtAGlanceReply.payload
                        && response.data.repGetAccountsAtAGlanceReply.payload.repGetAccountsAtAGlanceData
                        && response.data.repGetAccountsAtAGlanceReply.payload.repGetAccountsAtAGlanceData.accountList
                        && response.data.repGetAccountsAtAGlanceReply.payload.repGetAccountsAtAGlanceData.accountList.accountInfo || [];

                    var accountFlagsObject = {};
                    var accountList = response.data.repGetAccountsAtAGlanceReply.payload.repGetAccountsAtAGlanceData.accountList.accountInfo || [];
                    
                    //Filter Account List - remove all election details for plans that ran out over a year ago and update election list count
                    if(accountList) {
                        for(var i = 0; i < accountList.length;) {
                            if(accountList[i].electionList && accountList[i].electionList.electionDetails) {
                                var electionDetails = accountList[i].electionList.electionDetails;                              
                                for(var j = 0; j < electionDetails.length;) {
                                    if(electionDetails[j].runOutEndDate && ((new Date() - new Date(electionDetails[j].runOutEndDate)) / 86400000) > 365) {
                                        accountList[i].electionList.electionDetails.splice(j, 1);
                                        accountList[i].electionListCount--;
                                    } else {
                                        j++;
                                    }
                                }
                                if(accountList[i].electionListCount == 0) {
                                    accountList.splice(i, 1);
                                } else {
                                    i++;
                                }
                            }
                        }
                    }
                    
                    var index = accountDataArray.length;
                    
                    var accountInfoPromises = _accountInfoPromises(accountList);

                    while(index--){
                        var info = accountDataArray[index];
                        var accountShortName = info.accountShortName;
                        accountFlagsObject[accountShortName] = true;
                    }

                    // individual flags still exist, however, these are combined indicators
                    accountFlagsObject["hasFSA"] = accountFlagsObject["HCRA"] || accountFlagsObject["DCRA"] || accountFlagsObject["HCRA_L"];
                    accountFlagsObject["hasHSA"] = accountFlagsObject["HSA"];
                    accountFlagsObject["hasHRA"] = accountFlagsObject["HRAW"] || accountFlagsObject["HRA"] || accountFlagsObject["HRAR"] || accountFlagsObject["HRAV"];


                    return $q.all(accountInfoPromises).then(
                        function(response){
                            for (var z=0; z < response.length; z++) {
                                var detailAccountInfo = response[z].data.repAccountInfoReply.payload.repAccountInfoData.accountList;
                                for (var x=0; x < detailAccountInfo.length; x++) {
                                    if(hasDebitCard){
                                        break;
                                    } else {
                                        for (var y=0; y < detailAccountInfo[x].accountOptionList.length; y++) {
                                            if (detailAccountInfo[x].accountOptionList[y].name == "Debit Card" && detailAccountInfo[x].accountOptionList[y].value == "Yes") {
                                                hasDebitCard = true;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }

                            return {
                                accountFlag : accountFlagsObject,
                                accountList : accountList,
                                hasDebitCard : hasDebitCard
                            };
                        },
                        function(error){
                            return defaultSpendingObject;
                        }
                    );
                },
                function(error){
                    return defaultSpendingObject;
                }
            );
        };
    }]);

    app.controller('pages.spending', ["brand", "$scope", "spendingNavigation", "contentNavigationService", "spendingResourceServices", "session", "$window", "sessionData", "services", "$cookies", "spendingActionsNeeded", "storageOld", "$q", "spendingAccountsService","aemContentResourceServices",
        function (brand, $scope, spendingNavigation, contentNavigationService, spendingResourceServices, session, $window, sessionData, services, $cookies, spendingActionsNeeded, storageOld, $q,spendingAccountsService,aemContentResourceServices) {
        $window.document.title = "Member Spending";

        $scope.backText = 'Back';
        $scope.backAction = function () {
            $window.history.back();
        };

        $scope.coveredExpenses = function () {
            $window.location = "http://hcet.ebia.com/hmrk";
        };

        $scope.headings = "Spending";

        var clientNumber = $cookies.get("mbrClientNumber");
        var umiWithSuffix = sessionData.memberInfo.umi + '0';
        var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(sessionData.memberInfo);

        var sidebarContentIDs = {
            "MBR_NAVIGATION_SPENDING_SUMMARY": "MBR_NAVIGATION_SPENDING_SUMMARY",
            "MBR_COST_SAVING_TOOLS_NAVIGATION": "MBR_COST_SAVING_TOOLS_NAVIGATION",
            "MBR_NAVIGATION_SPENDING_FORMS_POST": "MBR_NAVIGATION_SPENDING_FORMS_POST",
            "MBR_NAVIGATION_SPENDING_COVERED_EXPENSES": "MBR_NAVIGATION_SPENDING_COVERED_EXPENSES",
            "MBR_NAVIGATION_SPENDING_EDUCATIONALMATERIALS": "MBR_NAVIGATION_SPENDING_EDUCATIONALMATERIALS",
            "MBR_NAVIGATION_SPENDING_CLAIMS": "MBR_NAVIGATION_SPENDING_CLAIMS",
            "MBR_NAVIGATION_SPENDING_RECEIPTS": "MBR_NAVIGATION_SPENDING_RECEIPTS",
            "MBR_NAVIGATION_SPENDING_DEBIT_CARD": "MBR_NAVIGATION_SPENDING_DEBIT_CARD",
            "MBR_NAVIGATION_SPENDING_TRANSACTIONS": "MBR_NAVIGATION_SPENDING_TRANSACTIONS",
            "MBR_NAVIGATION_SPENDING_ACCOUNT": "MBR_NAVIGATION_SPENDING_ACCOUNT"
        };

        function registerSidebarLinkPromise(promise, sidebarLink) {
            $q.when(promise, function (response) {
                if (response) {
                    $scope.sidebar.links.push(sidebarLink);
                    $scope.sidebar.links.sort(function (a, b) {
                        return a.order > b.order;
                    });
                }
            });
        }

        $scope.sidebar.links = [];

        $scope.$watch(function () {
            return sessionData.loggedIn;
        }, function () {
            var linksObj = {};

           /*services.rbsmbl.contentInfo().getContent(sidebarContentIDs, {}).then(function (response) {
                var linksObj = {};
                var links = (response
                    && response.data
                    && response.data.payload
                    && response.data.payload.contentResponse)
                        ? response.data.payload.contentResponse: [];

                links.forEach(function (link) {
                    try {
                        var content = JSON.parse(link["value"]);
                        
                        if (content.externalLink && content.externalLink === "Yes") {
                            content.newWindow = true;
                        }

                        linksObj[link["name"]] = content;
                    } catch(e) {
                        throw new Error(e);
                    }
                });

                var conditionalContentIDs = [
                    "MBR_NAVIGATION_SPENDING_ACCOUNT",
                    "MBR_NAVIGATION_SPENDING_COVERED_EXPENSES",
                    "MBR_NAVIGATION_SPENDING_CLAIMS",
                    "MBR_NAVIGATION_SPENDING_TRANSACTIONS",
                    "MBR_NAVIGATION_SPENDING_RECEIPTS",
                    "MBR_NAVIGATION_SPENDING_DEBIT_CARD",
                    "MBR_NAVIGATION_SPENDING_FORMS_POST",
                    "MBR_NAVIGATION_SPENDING_EDUCATIONALMATERIALS"
                ];
            }, function (error) {
            throw new Error(error);
            });*/

            // Add unconditional links to the sidebar.
            /*   for (var key in linksObj) {
             if (conditionalContentIDs.indexOf(key) == -1) {
             $scope.sidebar.links.push(linksObj[key]);
             }
             }
             var sidebarLinkObj = function(heading,label,href,description,state,active){
             this.heading = heading;
             this.label = label;
             this.href=href;
             this.active = active;
             this.description = description;
             this.state = state;
             }

             /* $scope.sidebar.links.push({
             heading: "Benefit Search",
             label: "Benefit Search",
             active: true,
             description: "Quickly locate your benefit costs and coverage",
             state: "coverage.benefitSearch"
             });*/

            var sidebarLinkObj = function(heading,label,href,description,state,active,order){
                this.heading = heading;
                this.label = label;
                this.href=href;
                this.active = active;
                this.description = description;
                this.state = state;
                this.order=order;
            };
            //$scope.sidebar.links.push(new sidebarLinkObj("Spending Summary","Spending Summary","","A quick look at your spending activity, including your balance, alerts and your progress towards deductible and out of pocket limits.","spending",false));

            $scope.sidebar.links.push({
                "state": "spending",
                "label": "Spending Summary",
                "heading": "Spending Summary",
                "description": "A quick look at your spending activity, including your balance, alerts and your progress towards deductible and out of pocket limits."

            });

                // Manage Spending Account logic
                if (portalSelectedPlan.spendingAccountExistsIndicator === "true" ||  portalSelectedPlan.hsaEnrollmentInProcessIndicator=="true") {
                   // $scope.sidebar.links.push(linksObj["MBR_NAVIGATION_SPENDING_ACCOUNT"]);
                    $scope.sidebar.links.push({
                        "state": "spending.spendingAccount",
                        "label": "Manage Spending Account",
                        "heading": "Manage Spending Account",
                        "description": "Choose how to best manage your funds. Current balance and account activity let you see where you stand."

                    });
                    //$scope.sidebar.links.push(new sidebarLinkObj("Manage Spending Account","Manage Spending Account","","Choose how to best manage your funds. Current balance and account activity let you see where you stand","spending.spendingAccount",false));
                }

                    // Spending Claims logic
                if (portalSelectedPlan.spendingAccountExistsIndicator === "true") {
                    $scope.sidebar.links.push({
                        "state": "spending.spendingClaims",
                        "label": "Spending Claims",
                        "heading": "Spending Claims",
                        "description": "See spending claims you entered. Other claims can be found under Claims.",
                        refineTemplate: 'spending/spendingClaims.appTemplate.html/chmhom/pages/spending/spendingClaimsRefine',
                        refineController: "spending.spendingClaims"

                    });
                     //$scope.sidebar.links.push(linksObj["MBR_NAVIGATION_SPENDING_CLAIMS"]);
                }

               /* // Covered Expenses logic
               if (brand.current.ubk !== 6010 && brand.current.ubk !== 6011 && brand.current.ubk !== 6012) {
                   $scope.sidebar.links.push(linksObj["MBR_NAVIGATION_SPENDING_COVERED_EXPENSES"]);
               }*/

               /*// remove educational material for wy
               if (brand.current.ubk !== 6012) {
                   $scope.sidebar.links.push(linksObj["MBR_NAVIGATION_SPENDING_EDUCATIONALMATERIALS"]);
               }*/

              /* // remove for forms library for wy and nd
               if (brand.current.ubk !== 6012 && brand.current.ubk !== 6011) {
                   $scope.sidebar.links.push(linksObj["MBR_NAVIGATION_SPENDING_FORMS_POST"]);
               }*/

                /*// Spending Claims logic
                if (portalSelectedPlan.spendingAccountExistsIndicator === "true") {
                    $scope.sidebar.links.push(linksObj["MBR_NAVIGATION_SPENDING_CLAIMS"]);
                }*/

               /* // Receipts logic
                if (portalSelectedPlan.spendingAccountExistsIndicator === "true") {
                    $scope.sidebar.links.push(linksObj["MBR_NAVIGATION_SPENDING_RECEIPTS"]);
                }
*/

                // Transaction History logic
                registerSidebarLinkPromise(function () {
                    var deferred = $q.defer();
                    if (brand.current.ubk == 6010) {
                        services.rbsmbl.vendorDetails().fetch({
                            "memberid": sessionData.memberInfo.umi,
                            "groupnumber": portalSelectedPlan.groupNumber,
                            "clientnumber": clientNumber
                        }).then(function (response) {
                            var vendorCode = (response
                                && response.data
                                && response.data.payload
                                && response.data.payload.vendorCode
                                && typeof(response.data.payload.vendorCode) === 'string')
                                    ? response.data.payload.vendorCode : "";
                            
                            deferred.resolve(vendorCode.toUpperCase() !== "PAYFLEX" && vendorCode !== "");
                        }, function (error) {
                            deferred.resolve(false);
                        });
                    } else {
                        deferred.resolve(portalSelectedPlan.spendingAccountExistsIndicator === "true");
                    }
                    return deferred.promise;
                }(),
                    //linksObj["MBR_NAVIGATION_SPENDING_TRANSACTIONS"]);
                    {
                        "state": "spending.transactionHistory",
                        "label": "Transaction History",
                        "heading": "Transaction History",
                        "description": "View detailed activity to your FSA, HRA or HSA spending account(s).",
                        refineTemplate: 'spending.appTemplate.html/chmhom/pages/spending/transactionHistoryRefine',
                        refineController: "spending.transactionHistory"
                    });

                if (portalSelectedPlan.spendingAccountExistsIndicator === "true") {
                    $scope.sidebar.links.push({
                        "state": "spending.receipts",
                        "label": "Receipts",
                        "heading": "Uploaded Receipts",
                        "description": "Find your uploaded receipts here. Receipts can be used to validate purchases or payments.",
                        refineTemplate: 'spending/receipts.appTemplate.html/chmhom/pages/spending/receiptsRefine',
                        refineController: "spending.receipts"

                    });
                }
                $scope.sidebar.links.push({
                    "state": "spending.costSavingTools",
                    "label": "Cost-Saving Tools",
                    "heading": "Cost-Saving Tools",
                    "description": "Find ways to save on your health care expenses."
                });

                if (brand.current.ubk !== 6012 && brand.current.ubk !== 6011) {
                    $scope.sidebar.links.push({
                        "state": "spending.forms",
                        "label": "Forms Library",
                        "heading": "Find A Form",
                        "description": "Find claim forms and other helpful resources."
                    });
                }
                //TODO : add different links based on the brands
                if (brand.current.ubk !== 6010 && brand.current.ubk !== 6011 && brand.current.ubk !== 6012) {
                    $scope.sidebar.links.push({
                        "label": "Covered Expenses",
                        "href": "http://hcet.ebia.com/hmrk",
                        "externalLink": "Yes",
                        "newWindow": true,
                        "coremetricsCategory": "MEMBER:SPENDING",
                        "coremetricsElement": "COVERED EXPENSES"
                    });
                }

                if (brand.current.ubk !== 6012) {
                    $scope.sidebar.links.push({
                        "state": "spending.educationalMaterial",
                        "label": "Educational Material",
                        "heading": "REVIEW AVAILABLE EDUCATIONAL MATERIALS",
                        "description": "You can review the educational documents and videos here to learn more about your claims section and EOBs.",
                        "refineTemplate": 'spending/educational-materials.appTemplate.html/chmhom/pages/claims/educationalMaterialRefine'
                    });
                };


                // Debit Card logic
                registerSidebarLinkPromise(function () {
                    var deferred = $q.defer();
                    spendingResourceServices.getSpendingAccounts(sessionData.memberInfo, clientNumber).then(function (spendingAccounts) {
                        deferred.resolve(spendingAccounts.hasDebitCard);
                    }, function (error) {
                        deferred.resolve(false);
                    });
                    return deferred.promise;
                }(),
                    //linksObj["MBR_NAVIGATION_SPENDING_DEBIT_CARD"]);
                    {
                        "state": "spending.debitCard",
                        "label": "Debit Card",
                        "heading": "Debit Card",
                        "description": "Everything you need to know about your debit card is here for your convenience."
                    });

                //to show pay premium  side bar : TODO -verify with SPA code base

                var payPremiumEnabledBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'pp', '6011','la'];
                var shouldGoToBilling = payPremiumEnabledBrands.indexOf(brand.current.sharedBrandCode) !== -1;
                var hidePayPremium = null;
                var directPay = sessionData.memberInfo.clientList[0].groupList[0].directPayIndicator;
                var medicare = sessionData.memberInfo.clientList[0].groupList[0].medicareIndicator;
                if(directPay === "true" || medicare === "true" && shouldGoToBilling){

                    hidePayPremium = false;
                }
                else{
                    hidePayPremium = true;
                }


                services.rbsmbl.ebillUserExists().getTargetUrl(brand).then(
                    function (response) {
                        if (response) {
                            var unregistered = response &&
                                response.data &&
                                response.data.payload &&
                                response.data.payload.ebillAccountexists === "N";
                            if(unregistered){
                                $scope.sidebar.links.push({
                                    "state": "payPremium",
                                    "label": "Pay Health Plan Premium",
                                    "externalLink": "Yes",
                                    "newWindow": true,
                                    "hide": hidePayPremium,
                                    "heading": "Pay Premium",
                                    "description": "You can pay your plan premium"
                                });
                            }
                            else{
                                $scope.sidebar.links.push({
                                    "label": "Pay Health Plan Premium",
                                    "href": "/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/EBILL?cm_sp=Ebill-_-Pay%20Monthly%20Premium-_-PAY%20MONTHLY%20PREMIUM",
                                    "externalLink": "Yes",
                                    "newWindow": true,
                                    "hide": hidePayPremium,
                                    "heading": "Pay Premium",
                                    "description": "You can pay your plan premium"
                                });
                            }
                        }
                    },
                    function (err) {
                        $scope.sidebar.links.push({
                            "state": "payPremium",
                            "label": "Pay Health Plan Premium",
                            "externalLink": "Yes",
                            "newWindow": true,
                            "hide": hidePayPremium,
                            "heading": "Pay Premium",
                            "description": "You can pay your plan premium"
                        });
                    }

                );

            // Do an initial sort based on the assigned order of each of the sidebar links.
            $scope.sidebar.links.sort(function (a, b) {
                return a.order > b.order;
            });
        });
    }]);

    return [
        {
            state: "spending",
            postPassword: true,
            appConfigMaintenanceApp: 'SPENDING',
            //appConfigMaintenanceKey: 'FULL_MAINTENANCE',
            url: "/spending",
            resolve: {
                spendingNavigation: ["contentNavigationService", function(contentNavigationService) {
                    return contentNavigationService.getNavigationIdListAsync();
                }],
                redirect: ['sessionData', '$q', '$window', function (sessionData, $q, $window) {
                    var deferred = $q.defer();
                    if (sessionData.isClaimsAndSpending) {
                        if ($cookies.get('statePriorToSpending')) {
                            deferred.reject();
                        } else {
                            var route = $window.location.hash;
                            route = route.replace('#', '');
                            route = route.replace('/spending', '');
                            route = route.replace('/', '');

                            switch (route) {
                            case "spendingAcccount":
                            case "":
                            default:
                                $window.location = "/member/claims-and-spending/spending-accounts";
                            }

                            deferred.reject();
                        }
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                }]
            },
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/categoryCustom.html'],
                    controller: "pages.spending"
                },
                "leftColumn@spending": {
                    //empty
                },
                "content@spending": {
                   // template: require('pages/spending/spendingSummary.html'),
                    templateUrl: 'spending.appTemplate.html/chmhom/pages/spending/spendingSummary',
                    controller: "pages.spending.spendingSummary"
                }
            }
        },
        {
            state: "spending.receiptRequired",
            appConfigMaintenanceApp: 'SPENDING',
            //appConfigMaintenanceKey: 'ACTIVITY_SUMMARY_MAINTENANCE',
            url: "/receiptRequired",
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/detailCustom.html'],
                    controller: "pages.spending"
                },
                "leftColumn@spending.receiptRequired": {
                    //empty
                },
                "content@spending.receiptRequired": {
                    templateUrl: 'spending.appTemplate.html/chmhom/pages/spending/receiptRequired',
                    controller: "pages.spending.receiptRequired"
                },
                "rightColumn@claims": {
                    // empty
                }
            }
        },
        {
            state: "spending.claimsMatchingConfirm",
            appConfigMaintenanceApp: 'SPENDING',
            //appConfigMaintenanceKey: 'ACTIVITY_SUMMARY_MAINTENANCE',
            url: "/claimsMatchingConfirm",
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/detailCustom.html'],
                    controller: "pages.spending"
                },
                "leftColumn@spending.receiptRequired": {
                    //empty
                },
                "content@spending.claimsMatchingConfirm": {
                    templateUrl: 'spending.appTemplate.html/chmhom/pages/spending/claimsMatchingConfirm',
                    controller: "pages.spending.claimsMatchingConfirm"
                },
                "rightColumn@claims": {
                    // empty
                }
            }
        },
        {
            state: "spending.forms",
            postPassword: true,
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'FORMS_MAINTENANCE',
            url: "/forms",
            resolve: {
                resourcesList: ["aemContentResourceServices", function(aemContentResourceServices){
                    return aemContentResourceServices.getResourceIdListAsync();
                }],
                redirect: ['brand','$q','$window', function (brand,$q,$window) {
                   var newFormsBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'hmbcbsde', 'pp'];
                    var deferred = $q.defer();
                    if(newFormsBrands.indexOf(brand.current.sharedBrandCode.toLowerCase())>-1){
                        $window.location = "/member/forms";
                        deferred.reject();
                    }else{
                        deferred.resolve();
                    }
                    return deferred.promise;
                }]
            },
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/category.html"],
                    controller: "pages.spending"
                },
                "content@spending.forms": {
                    templateUrl:'spending/forms.appTemplate.html/chmhom/pages/spending/forms',
                    controller: "pages.spending.forms"
                }
            }


        },
        {
            state: 'spending.costSavingTools',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'COST_SAVING_TOOLS_MANTENACE',
            url: '/cost-saving-tools',
            postPassword: true,
            resolve: {
                /*resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }]*/
            },
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/category.html"],
                    controller: "pages.spending"
                },
                "content@spending.costSavingTools": {
                    templateUrl: 'spending.appTemplate.html/chmhom/pages/spending/costSavingTools',
                    controller: "pages.spending.costSavingTools"
                }
            }
        },
        {
            state: 'spending.debitCard',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'DEBIT_CARD',
            url: '/manageDebitCard',
            postPassword: true,
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.spending"
                },
                "content@spending.debitCard": {
                    templateUrl: 'spending.appTemplate.html/chmhom/pages/spending/debitCard',
                    controller: "pages.spending.debitCard"
                }
            }
        },
        {
            state: 'spending.spendingAccount',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'MANAGE_SPENDING_ACCOUNT',
            url: '/spendingAccount',
            postPassword: true,
            resolve: {
                resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }],
                accountTypes: ["spendingAccountsService", function(spendingAccountsService){
                    return spendingAccountsService.getAccountTypes();
                }]
            },
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.spending"
                },
                "content@spending.spendingAccount": {
                    //template: require("./spending/manageSpendingAccount.html"),
                    templateUrl: 'spending/spendingAccount.appTemplate.html/chmhom/pages/spending/manageSpendingAccount',
                    controller: "pages.spending.manageSpendingAccount"
                }
            }
        },
        {
            state: 'spending.transactionHistory',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'TRANSACTION_HISTORY',
            url: '/transactionHistory',
            postPassword: true,
            resolve: {

                accountTypes: ["spendingAccountsService", function(spendingAccountsService){
                    return spendingAccountsService.getAccountTypes();
                }]
            },

            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.spending"
                },
                "content@spending.transactionHistory": {
                    //template: require("./spending/transactionHistory.html"),
                    templateUrl: 'spending/transactionHistory.appTemplate.html/chmhom/pages/spending/transactionHistory',
                    controller: "pages.spending.transactionHistory"
                }
            }
        },
        {
            state: 'spending.receipts',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'SPENDING_RECEIPTS',
            url: '/receipts',
            postPassword: true,
            resolve: {
                resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }]
            },
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.spending"
                },
                "content@spending.receipts": {
                    templateUrl: 'spending.appTemplate.html/chmhom/pages/spending/receipts',
                    controller: "pages.spending.receipts"
                }
            }
        },

        {
            state: 'spending.newClaims',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'SPENDING_NEW_CLAIMS',
            url: '/newClaims',
            postPassword: true,
            resolve: {
                resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }]
            },
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/detailCustom.html"],
                    controller: "pages.spending"
                },
                "leftColumn@spending.newClaims": {
                    templateUrl: 'spending.appTemplate.html/chmhom/directives/spending/manageSpendingAccountSection',
                    controller: 'directive.spending.manageSpendingAccount'
                },
                "content@spending.newClaims": {
                    templateUrl: 'spending/newClaims.appTemplate.html/chmhom/pages/spending/newClaims',
                    controller: "pages.spending.newClaims"
                }
            }
        },
        {
            state: "spending.educationalMaterial",
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'EDUCATIONAL_MATERIALs_MAINTENANCE',
            postPassword: true,
            url: "/educational-materials",
            resolve: {
                resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }]
            },
            views: {
                "content@spending": {
                    templateUrl: 'spending.appTemplate.html/chmhom/pages/claims/educationalMaterial',
                    controller: "pages.claims.educationalMaterial"
                }
            }
        },
        {
            state: 'spending.clientListSelection',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'SPENDING_CLIENT_SELECTION',
            url: '/clientListSelection',
            postPassword: true,
            resolve: {
                resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }]
            },
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/detailCustom.html"],
                    controller: "pages.spending"
                },
                "content@spending.clientListSelection": {
                    templateUrl: 'spending/clientListSelection.appTemplate.html/chmhom/pages/spending/clientListSelection',
                    controller: "pages.spending.clientListSelection"
                }
            }
        },
        {
            state: 'spending.groupSelection',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'SPENDING_CLIENT_SELECTION',
            url: '/groupSelection',
            postPassword: true,
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.spending"
                },
                "content@spending.groupSelection": {
                    templateUrl: 'spending.appTemplate.html/chmhom/pages/spending/groupSelection',
                    controller: "pages.spending.clientListSelection"
                }
            }
        },
        {
            state: 'spending.newReceipt',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'SPENDING_NEW_RECEIPT',
            url: '/newReceipt',
            postPassword: true,
            resolve: {
                resourcesList: ["contentResourceServices", function(contentResourceServices){
                    return contentResourceServices.getResourceIdListAsync();
                }]
            },
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/detailCustom.html"],
                    controller: "pages.spending"
                },
                "content@spending.newReceipt": {
                    templateUrl: 'spending/newReceipt.appTemplate.html/chmhom/pages/spending/newReceipt',
                    controller: "pages.spending.newReceipt"
                }
            }
        },
        {
            state: 'spending.spendingAccountSettings',
            appConfigMaintenanceApp: 'SPENDING',
            appConfigMaintenanceKey: 'SPENDING_ACCOUNT_SETTINGS',
            url: '/spendingAccountSettings',
            postPassword: true,
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/detailCustom.html"],
                    controller: ["$scope", "$window", function ($scope, $window) {
                        $scope.headings = "SPENDING ACCOUNT";
                        $scope.backText = 'Back';
                        $scope.backAction = function () {
                            $window.history.back();
                        };
                    }]
                },
                "content@spending.spendingAccountSettings": {
                    templateUrl: 'spending/spendingAccountSettings.appTemplate.html/chmhom/pages/spending/spendingAccountSettings',
                    controller: "pages.spending.spendingAccountSettings"
                }
            }
        },
        {
            state: 'spending.spendingClaims',
           // appConfigMaintenanceApp: 'SPENDING',
           // appConfigMaintenanceKey: 'SPENDING_NEW_RECEIPT',
            url: '/spendingClaims',
            postPassword: true,
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.spending"
                },
                "content@spending.spendingClaims": {
                    templateUrl: 'spending/spendingClaims.appTemplate.html/chmhom/pages/spending/spendingClaims',
                    controller: "pages.spending.spendingClaims"

                }
            }
        }
    ];
};